import React from "react";
import { Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const BookingDetails = ({ selectedMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const getBookingContent = () => {
    switch (selectedMenu) {
      case "HOME":
        return "Book Your Airport Transfer Now";
      case "ABOUT WATFORD TAXI":
        return "Learn More About Our Taxi Services";
      case "AIRPORT TAXI":
        return "Reliable Airport Taxis in Watford";
      case "SERVICES":
        return "Explore Our Wide Range of Services";
      case "CONTACT US":
        return "Get in Touch With Us Today";
      default:
        return "Book Your Ride with Us Now";
    }
   
  };

  return (
    <section className="bg-dark z-[100] container mx-auto px-4 md:px-8 lg:px-16 py-6 border-[7px] border-yellow-500 rounded-lg shadow-lg relative mt-[-100px]">
      <h2 className="text-2xl font-semibold text-white mb-4">{getBookingContent()}</h2>
      <div className="text-white">
           <Button 
  variant="outlined" 
  color="primary"
  size="large"
  sx={{
    border: '3px solid',
    borderColor: "#FFC61A",
    color: "#FFC61A",
    fontWeight: 700,
    px: 4,
    py: 1.5,
    '&:hover': {
      backgroundColor: "#FFC61A",
      borderColor: "#FFC61A",
      color: '#363E66'
    }
  }}
  onClick={() => {
    // Navigate to home if not already there
    if (location.pathname !== "/") {
      navigate("/");
      // Wait for navigation to complete before scrolling
      setTimeout(() => {
        const bookNowSection = document.getElementById('book-now');
        if (bookNowSection) {
          bookNowSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Small delay to allow page transition
    } else {
      // Already on home page, just scroll
      const bookNowSection = document.getElementById('book-now');
      if (bookNowSection) {
        bookNowSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }}
>
  Book Now
</Button>
        <p className="text-2xl">01923 803 603</p>
      </div>
    </section>
  );
};

export default BookingDetails;


